import { useState, useEffect, useMemo } from "react";

const FieldingTable = ({ tableContent, selectedFilter, selectedYear }) => {
  const [dataColumns, setDataColumns] = useState([]);
  const [visibleCount, setVisibleCount] = useState(20);

  useEffect(() => {
    const columns = [
      {
        key: "most_catches",
        label: "Catches",
        highlight: "Most Catches",
      },
      {
        key: "matches_played",
        label: "Matches",
      },
      {
        key: "most_run_outs",
        label: "Run Outs",
        highlight: "Most Run Outs",
      },
      {
        key: "most_dismissals",
        label: "Dismissals",
        highlight: "Most Dismissals",
      },
    ];

    const selectedIndex = columns.findIndex(item => item.highlight === selectedFilter);
    if (selectedIndex > 0) {
      const [selectedColumn] = columns.splice(selectedIndex, 1);
      columns.unshift(selectedColumn);
    }

    setDataColumns(columns);
    setVisibleCount(20); // Reset on filter change
  }, [selectedFilter]);

  const sortedTableContent = useMemo(() => {
    if (!tableContent || !dataColumns.length) return [];

    const key = dataColumns[0]?.key;
    if (!key) return tableContent;

    return [...tableContent].sort((a, b) => {
      const valA = parseFloat(a[key]);
      const valB = parseFloat(b[key]);
      return isNaN(valB) - isNaN(valA) || valB - valA;
    });
  }, [tableContent, dataColumns, selectedFilter]);

  const handleLoadMore = () => {
    setVisibleCount(sortedTableContent.length);
  };

  return (
    <div className="relative">
      <div className="md:w-full md:overflow-hidden overflow-x-auto">
        <div className="flex py-3 min-w-[800px]">
          <div className="flex w-[35%]">
            <div className="text-[14px] font-[400] text-[#000000] dark:text-[#FFFFFF80] w-[20%] text-center">
              Pos
            </div>
            <div className="text-[14px] font-[400] text-[#000000] dark:text-[#FFFFFF80] w-[80%]">
              Player Name
            </div>
          </div>
          <div className="w-[65%] text-center">
            <div className="flex items-center justify-around">
              {dataColumns.map((item, index) => (
                <div
                  key={index}
                  className={`text-[14px] ${selectedFilter === item?.highlight ? "font-bold" : "font-[400]"
                    } text-[#000000] dark:text-white ${item?.key === "five_wickets_haul" || item?.key === "three_wickets_haul"
                      ? "w-[18%]"
                      : "w-[24%]"
                    }`}
                >
                  {item?.label}
                </div>
              ))}
            </div>
          </div>
        </div>

        {sortedTableContent?.slice(0, visibleCount).map((value, index) => (
          <div
            key={index}
            className={`flex ${index % 2 === 0 ? "bg-gray-200 dark:bg-gray-800" : "bg-white dark:bg-[#1F1F1F]"
              } py-3 min-w-[800px] items-center`}
          >
            <div className="flex w-[35%] items-center">
              <div className="text-[14px] font-[400] text-[#525358] dark:text-[#FFFFFF80] w-[20%] text-center">
                {index + 1}
              </div>
              <div className="text-[14px] font-[400] text-[#525358] dark:text-[#FFFFFF80] w-[80%]">
                <div className="flex items-center">
                  <img
                    width="50"
                    height="50"
                    className="w-[50px] h-[50px] mr-3 rounded-full"
                    src={`https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/${value?.player_id}.png`}
                    onError={(e) => {
                      e.target.src =
                        "https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/0.png";
                    }}
                    alt={value.player_name}
                  />
                  <div className="font-semibold text-[#525358] dark:text-[#FFFFFFCC]">
                    {value.player_name}
                    <div className="font-normal">
                      {value?.team_short_name ?? "-"}
                    </div>
                  </div>
                  {selectedFilter === "Most Wickets" && index === 0 && (
                    <img className="h-5 ml-2" src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/purple_cap.png" alt="Purple Cap" />
                  )}
                </div>
              </div>
            </div>
            <div className="w-[65%] text-center">
              <div className="flex items-center justify-around">
                {dataColumns.map((item, index) => (
                  <div
                    key={index}
                    className={`text-[14px] ${selectedFilter === item?.highlight
                      ? "font-bold text-[#000] dark:text-white"
                      : "font-[400] text-[#525358] dark:text-[#ffffffcc]"
                      } ${item?.key === "five_wickets_haul" || item?.key === "three_wickets_haul"
                        ? "w-[18%]"
                        : "w-[24%]"
                      }`}
                  >
                    {value[item?.key] ?? "-"}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* View All / Load More button */}
      <div className="flex justify-center w-full">
        {visibleCount < sortedTableContent.length && (
          <div
            onClick={handleLoadMore}
            className="flex cursor-pointer justify-center content-center text-center rounded-full h-10 w-auto p-[10px] bg-primary mt-4 text-white dark:text-[#1f1f1f]"
          >
            सभी देखें
          </div>
        )}
      </div>
    </div>
  );
};

export default FieldingTable;
